import { showToast } from "./tostr";
import { useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {logout} from "../store/slices/AuthSlice";
import {useDispatch} from "react-redux";

export function useSetupAxiosInterceptors() {
  // Use useRef to prevent a re-render in the useEffect.
  const navRef = useRef(useNavigate());
    const dispatch = useDispatch();

  useEffect(() => {
    axios.interceptors.request.use((config) => {
      return config;
    });

    const intercetpor = axios.interceptors.response.use(
      (response) => {
        if( response?.message?.code==='USR018'){
            showToast(
                "Session Expired! Please Login again.",
                "error",
                response.data.status
            );
            dispatch(logout());
            navRef.current("/login");
        }
        if(response?.message?.code==='USR019'){
                showToast(
                    "Unauthorized Access!",
                    "error",
                    response.data.status
                );
        }
        return response;
      },
      (error) => {
        switch (error?.response?.status) {
          case 401:
          case 403:
            //Clear localstorage
            localStorage.removeItem("authToken");
            showToast(
              "Session Expired! Please Login again.",
              "error",
              error?.response?.status
            );
            //Redirect to login page
            navRef.current("/login");
            break;
          case 500:
            showToast(
              "An Error occurred. Please contact Vitraya's admin.",
              "error",
              error?.response?.status
            );
            break;
          case 503:
            showToast(
              "Services are currently down. Please try again in some time.",
              "error",
              error?.response?.status
            );
            break;
          case 504:
            showToast(
              "Process timeout!! Please try again.",
              "error",
              error?.response?.status
            );
            break;
          default:
        }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.response.eject(intercetpor);
    };
  }, []);
}

export default function SetupAxiosInterceptors() {
  useSetupAxiosInterceptors();
  return <></>;
}
